import { useQuery } from '@tanstack/react-query';

import { DreConfiguracao } from '../../types';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';

export function useQueryConfiguracoes() {
    const { activeGrupo, activeSubgrupo } = useDreConfigContext();
    const requestListagem = useRequestListagem();
    const { idDreMercadologicaTipoGrupoExibicao, dreMercadologicaTipoGrupoExibicaoEnum } = activeGrupo || {};
    const { idDreMercadologicaGrupoExibicao } = activeSubgrupo || {};

    return useQuery<DreConfiguracao[]>(
        ['queryConfiguracoes', idDreMercadologicaTipoGrupoExibicao, idDreMercadologicaGrupoExibicao],
        () =>
            requestListagem({
                url: '/dre/dremercadologicaconfiguracao/tipogrupoexibicao',
                extraParams: [{ idDreMercadologicaTipoGrupoExibicao }, { idDreMercadologicaGrupoExibicao }],
            }).then((res) => res.data),
        {
            enabled: Boolean(
                idDreMercadologicaTipoGrupoExibicao && (idDreMercadologicaGrupoExibicao || dreMercadologicaTipoGrupoExibicaoEnum === 'IMPOSTOS'),
            ),
        },
    );
}
